


























import { Vue, Prop, Component, Watch } from 'vue-property-decorator'

@Component
export default class extends Vue {
  @Prop({ default: 'pencil' }) public icon!: string
  @Prop({ default: 'แก้ไข' }) public text!: string
  @Prop({ default: false }) public disabled!: boolean
  @Prop({ default: undefined }) public color!: string
  @Prop({ default: () => null }) public onClick!: () => void
  @Prop({ default: true }) public isIcon!: boolean
}
